import { lighten } from '@material-ui/core';
import { Box, Rating, useTheme } from '@mui/material';
import React from 'react';

interface StarRatingProps {
    rating: number;
    size: 'small' | 'medium' | 'large';
}

const StarRating: React.FC<StarRatingProps> = ({ rating, size = 'small' }) => {
    const theme = useTheme();

    return (
        <Box display='flex' alignItems='center' gap={1}>
            <Rating
                value={rating}
                readOnly={true}
                size={size}
                precision={0.1}
                sx={{
                    '& .MuiRating-iconFilled': {
                        color: 'secondary.main',
                    },
                    '& .MuiRating-iconEmpty': {
                        color: theme.palette.custom.grey,
                    },
                }}
            />
        </Box>
    );
};

export default StarRating;
